<template>
  <Toast
    position="top-left"
    group="headlessProgress"
    severity="info"
  >
    <template #container>
      <div class="p-4 rounded-lg toastProgressContainer text-black dark:text-black shadow-md w-full">
        <div v-if="progressRecipePriceUpdateDisplayed" class="toast-progress-section">
          <div class="flex items-center gap-3 mb-2">
            <i class="pi pi-cloud-upload text-xl" />
            <span class="font-semibold">Mise à jour des prix recette</span>
          </div>
          <ProgressBar
            :value="progressToUpdatePrice"
            :showValue="false"
            class="h-1"
          />
          <p class="text-xs mt-2 font-medium">
            {{ recipesToUpdatePriceProcessedCount }} / {{ recipesToUpdatePriceToProcessTotalCount }} recettes mises à jour
          </p>
        </div>

        <div v-if="progressRecipeToLoadDetailDisplayed" class="toast-progress-section">
          <div class="flex items-center gap-3 mb-2">
            <i class="pi pi-cloud-upload text-xl" />
            <span class="font-semibold">Chargement du détail des recettes</span>
          </div>
          <ProgressBar
            :value="progressToLoadDetail"
            :showValue="false"
            class="h-1"
          />
          <p class="text-xs mt-2 font-medium">
            {{ recipesToLoadDetailProcessedCount }} / {{ recipesToLoadDetailToProcessTotalCount }} recettes chargées
          </p>
          <div>
            <Button
              label="Arreter"
              ico="pi pi-stop"
              @click="stopLoadDetail"
              />
          </div>
        </div>

        <div v-if="progressMenuLoadDisplayed" class="toast-progress-section">
          <div class="flex items-center gap-3 mb-2">
            <i class="pi pi-euro text-xl" />
            <span class="font-semibold">Chargement des informations menus</span>
          </div>
          <ProgressBar
            :value="progressMenuPriceHistory"
            :showValue="false"
            class="h-1"
          />
          <p class="text-xs mt-2 font-medium">
            {{ menuPriceHistoryProcessedCount }} / {{ menuPriceHistoryToProcessTotalCount }} menus chargés
          </p>
        </div>
      </div>
    </template>
  </Toast>

</template>

<script>
import { computed, watch } from 'vue'

import Toast from 'primevue/toast';
import { ProgressBar, Button } from 'primevue';


import { storeToRefs } from 'pinia';

import { useAdminDataStore } from '../../stores/admin';
import { useToast } from "primevue/usetoast";
import get from '../../services/get';

export default {
  name: "AdminToastPendingOperation",
  setup() {
    const adminDataStore = useAdminDataStore();
    
    
    const { 
      editedRecipe,

      recipesToUpdatePrice,
      recipesToUpdatePriceProcessedCount,
      recipesToUpdatePriceToProcessTotalCount,

      recipesToLoadDetail,      
      recipesToLoadDetailProcessedCount,
      recipesToLoadDetailToProcessTotalCount,

      menuPriceHistoryLoading,
      menuPriceHistoryProcessedCount,
      menuPriceHistoryToProcessTotalCount,

    } = storeToRefs(adminDataStore);
/*
    const recipesToUpdatePriceCount = computed(() => {
      return recipesToUpdatePrice.value.length;
    });
*/
    const toast = useToast();

    const clearToastProgress = () => {
        toast.removeGroup('headlessProgress');
    };

    const progressRecipePriceUpdateDisplayed = computed(() => {
      return recipesToUpdatePrice.value.length > 0;
    });

    const progressRecipeToLoadDetailDisplayed = computed(() => {
      return recipesToLoadDetail.value.length > 0;
    });

    const progressMenuLoadDisplayed = computed(() => {
      return menuPriceHistoryLoading.value;
    });

    const anyProgressDisplayed = computed(() => {
      return progressRecipePriceUpdateDisplayed.value
        || progressRecipeToLoadDetailDisplayed.value
        || progressMenuLoadDisplayed.value;
    });

    const progressToUpdatePrice = computed(() => {      
      if(recipesToUpdatePriceToProcessTotalCount.value == 0) {
        return 0;
      }
      return 100 * recipesToUpdatePriceProcessedCount.value / recipesToUpdatePriceToProcessTotalCount.value;
    });

    const progressToLoadDetail = computed(() => {      
      if(recipesToLoadDetailToProcessTotalCount.value == 0) {
        return 0;
      }
      return 100 * recipesToLoadDetailProcessedCount.value / recipesToLoadDetailToProcessTotalCount.value;
    });

    const progressMenuPriceHistory = computed(() => {
      if(menuPriceHistoryToProcessTotalCount.value == 0) {
        return 0;
      }
      return 100 * menuPriceHistoryProcessedCount.value / menuPriceHistoryToProcessTotalCount.value;
    });

    // Un seul toast regroupe toutes les opérations en cours pour éviter la superposition.
    watch(anyProgressDisplayed, () => {
      if(anyProgressDisplayed.value) {
        toast.add({
          severity: 'custom',
          group: 'headlessProgress',
          styleClass: 'shadow-lg rounded-xl px-4 py-3'
        });
      }else{
        clearToastProgress();
      }
    });

    watch(progressRecipePriceUpdateDisplayed, () => {
      if(!progressRecipePriceUpdateDisplayed.value) {
        adminDataStore.resetToUpdatePrices();
      }
    });
    watch(progressRecipeToLoadDetailDisplayed, () => {
      if(!progressRecipeToLoadDetailDisplayed.value) {
        adminDataStore.resetRecipeToLoadDetail();
      }
    });

    
    let isAlreadyUpdatingPrice = false;
    watch(recipesToUpdatePrice, async () => {
      if(isAlreadyUpdatingPrice) {
        return;
      }
      isAlreadyUpdatingPrice = true;
      if(recipesToUpdatePrice.value.length >= 1) {
        const foodRecipeId = recipesToUpdatePrice.value[0];

        let isEditedRecipe = false;
        if(editedRecipe.value && editedRecipe.value.id == foodRecipeId) {
          isEditedRecipe = true;
        }
        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(true);
        }
        await get.refreshFoodRecipeRecipePrice(foodRecipeId);

        adminDataStore.incrementRecipesToUpdatePriceProcessedCount();
        adminDataStore.setRecipesToUpdatePriceProcessed(foodRecipeId);

        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(false);
        }
      }
      isAlreadyUpdatingPrice = false;
    });

    
    let isAlreadyLoadingDetail = false;
    watch(recipesToLoadDetail, async () => {
      if(isAlreadyLoadingDetail) {
        return;
      }
      isAlreadyLoadingDetail = true;
      if(recipesToLoadDetail.value.length >= 1) {
        const foodRecipeId = recipesToLoadDetail.value[0];

        let isEditedRecipe = false;
        if(editedRecipe.value && editedRecipe.value.id == foodRecipeId) {
          isEditedRecipe = true;
        }
        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(true);
        }
        
        const forceRefresh = true;
        const doAjaxCall = true;
        await get.getFoodRecipe(foodRecipeId, forceRefresh, doAjaxCall);

        adminDataStore.incrementRecipesToLoadDetailProcessedCount();

        adminDataStore.setRecipesToLoadDetailProcessed(foodRecipeId);

        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(false);
        }
      }
      isAlreadyLoadingDetail = false;
    });

    const stopLoadDetail = () => {
      adminDataStore.resetRecipeToLoadDetail();
    };
           

    return {
      progressRecipePriceUpdateDisplayed,
      recipesToUpdatePriceProcessedCount,
      recipesToUpdatePriceToProcessTotalCount,
      progressToUpdatePrice,

      
      progressRecipeToLoadDetailDisplayed,
      recipesToLoadDetailProcessedCount,
      recipesToLoadDetailToProcessTotalCount,
      progressToLoadDetail,
      stopLoadDetail,

      progressMenuLoadDisplayed,
      menuPriceHistoryProcessedCount,
      menuPriceHistoryToProcessTotalCount,
      progressMenuPriceHistory,
    };
  },
  components: {
    Button,
    Toast,
    ProgressBar,
}
};
</script>

<style lang="scss">
  @import '../../css/backend.scss';

  .toast-progress-section + .toast-progress-section {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .field-checkbox {
    & > div, & > label {
      display: inline-block;
    }
  }
  .sendMultiMail {
    input.p-inputtext {
      width: 90%;
    }
    textarea.p-inputtextarea {
      width: 90%;
    }
  }
  .sm-admin {
    .pi-home {
      cursor: pointer;
      &.nothome {
        opacity: 0.2;
        color: red;
      }
    }
  }

</style>